import { createAuthStore } from '@uofu-uss-gis/ui-react';
import { classMapAuthAdapter, type ClassInfo, type CasUser } from '../adapter/classMapAuthAdapter';
import { env } from '../config/env';
import { loadOidcService } from '../services/oidcLoader';

/**
 * Authentication Store
 * 
 * Uses USS OIDC library for authentication with WSO2 API Gateway.
 * Once WSO2 admin whitelists application ID (26ed2aa3-841e-4d4f-b283-47eb4ea27ea2),
 * login will redirect to CAS for University SSO.
 */

export const useAuthStore = createAuthStore<CasUser, ClassInfo[]>(classMapAuthAdapter);

// Enhance the logout function to also clear OIDC session storage
const originalLogout = useAuthStore.getState().logout;
useAuthStore.setState({
	logout: () => {
		// Call the OIDC logout service to clear session storage
		// Set to true for full CAS logout (logs out of all university apps)
		// Set to false for local logout only (standard SSO - allows quick re-login)
		const performFullCASLogout = false; // Change to true if you want full logout
		
		void loadOidcService()
			.then(oidcService => {
				if (!oidcService) {
					return;
				}

				return oidcService.logout(performFullCASLogout);
			})
			.catch(error => {
				console.error('Error during OIDC logout:', error);
			});
		// Call the original logout to update the store state
		originalLogout();
	}
});

const useDummyAuth = env.useDummyAuth;

if (useDummyAuth) {
	const { setUseDummyAuth, checkAuth } = useAuthStore.getState();
	setUseDummyAuth(true);
	void checkAuth({ silent: true });
}

export type { ClassInfo, CasUser };
